<script>import { getRankIconInfo } from "@infinitro/global";
export let rank = void 0;
export let level = void 0;
export let size = null;
export let sizeAsPercent = false;
export let glow = false;
export let heightAuto = false;
$: info = getRankIconInfo(rank, level);
$: sizeUnit = sizeAsPercent ? "%" : "px";
$: sizeValue = size !== null ? `${size}${sizeUnit}` : null;
</script>

{#if info?.imageSrc}
	{@const { imageSrc, rankName } = info}
	<div class="rank-badge-container" style={sizeValue ? `width: ${sizeValue};` : ''}>
		<img
			src={imageSrc}
			alt={`${rankName} rank ${level}`}
			style={sizeValue ? `width: ${sizeValue}; height: auto;` : ''}
			class="badge"
			class:height-auto={heightAuto}
		/>
		{#if glow}
			<img src={imageSrc} alt={`${rankName} rank ${level}`} class="badge-glow" />
		{/if}
	</div>
{/if}

<style>
	.rank-badge-container {
		position: relative;
		display: inline-block;
}

	.badge {
		position: relative;
		z-index: 10;
		display: block;
		max-width: 100%;
		height: auto;
		-o-object-fit: contain;
		   object-fit: contain;
}

	.badge-glow {
		position: absolute;
		z-index: 0;
		--tw-blur: blur(24px);
		filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
		inset: 0;
		width: 100%;
		height: 100%;
		-o-object-fit: contain;
		   object-fit: contain;
		pointer-events: none;
}

	.height-auto {
		height: auto !important;
	}
</style>
